import type { HttpResponseErrorFormaterResult } from '@/features/fetch/extensions'

type ExtranetResponseError = {
  title: string
  status: number
  detail: string
  traceId: string
  exception: string | null
}

export async function extranetErrorFormater(response: Response): Promise<HttpResponseErrorFormaterResult> {
  const text = await response.text()

  try {
    const data = JSON.parse(text) as ExtranetResponseError
    const incident = `<strong>Numéro d'incident : ${data.traceId}</strong>`

    return {
      statut: `<strong>Statut ${data.status} : ${data.detail}</strong>`,
      content: data.exception
        ? [incident, '', ...data.exception.split('\n').map((str) => str.replace(/\s/g, '&nbsp;'))]
        : [incident],
    }
  } catch {
    const statut = response.statusText
      ? `<strong>Statut : ${response.status} ${response.statusText}</strong>`
      : `<strong>Statut : ${response.status} Erreur HTTP</strong>`
    return {
      statut,
      content: text
        .split('\n')
        .map((str) => str.trim())
        .filter((str) => !!str),
    }
  }
}

